'use client'

import { useEffect } from 'react'
import Button from './Button'

export default function Credits({ onBackHome }: { onBackHome: () => void }) {
  useEffect(() => {
    // AudioElement handles outro playback when view === 'credits'
  }, [])

  const handleBackHome = () => {
    onBackHome()
  }

  return (
    <div className="flex flex-col items-center justify-center w-full h-full px-4 py-8 text-white bg-black">
      <div className="max-w-2xl mb-8 text-center">
        <p className="mb-10 font-bold text-[20px] md:text-[28px] font-domine">
          We'd like to thank the following people who helped make this experience possible:
        </p>

        <div className="space-y-6">
          <div>
            <p className="font-light text-base md:text-[22px]">Authors: Mina Pomare-Pieta and Mutunga Rameka</p>
          </div>

          <div>
            <p className="font-light text-base md:text-[22px]">Voice talent: Kawiti Waetford and Mina Pomare-Pieta</p>
          </div>

          <div>
            <p className="font-light text-base md:text-[22px]">
              Kai tautoko: Joanne Murray, Maraea Herbert-Pickering, Selena Bercich, Bobby Proctor, Shane Tamati.
            </p>
          </div>

          <div>
            <p className="font-light text-base md:text-[22px]">Project manager: Kiri Reihana.</p>
            <p className="font-light text-base md:text-[22px]">Te Rarawa Anga Mua, Te Rarawa kaitiaki komiti</p>
          </div>

          <div>
            <p className="font-light text-base md:text-[22px]">
              VR by Waxeye: Paul James, Kelsey Jones, Amanda Goosen, Nisch Pokhrel, Vlad Vasin, Taura Greig, Mark
              Southcombe
            </p>
          </div>

          <div>
            <p className="font-light text-base md:text-[22px]">Sound design by Kahra Scott-James</p>
          </div>

          <div className="mt-10">
            <p className="font-light text-base md:text-[22px]">The End</p>
          </div>
        </div>
      </div>

      <div className="absolute px-4 py-2 bottom-4 right-4">
        <Button onClick={handleBackHome}>Back home</Button>
      </div>
    </div>
  )
}
